import { FormEventHandler } from 'react'
import { User, RoleBase } from '../../shared/types'
import { Button } from '../components/button'
import { Options, Select } from '../components/select'

type Props = {
	data?: User
	roles?: RoleBase[]
	onSubmit: FormEventHandler
	isPending?: boolean
}

export function UsersForm({ data, roles = [], onSubmit, isPending }: Props) {
	const options: Options = roles.map(role => ({ value: role.id, label: role.name }))
	options.unshift({ value: '', label: 'Vyberte' })
	return (
		<form className="space-y-4 m-auto max-w-[60em]" onSubmit={onSubmit}>
			<h3 className="text-md font-bold">Editace uživatele</h3>
			<div className="grid grid-cols-2 gap-4">
				<Select
					name="roleId"
					isRequired
					label="Role"
					options={options}
					defaultSelectedKey={data?.account_role_id}
				/>
			</div>
			<Button type="submit" isPending={isPending} isDisabled={isPending}>
				Uložit
			</Button>
		</form>
	)
}
